// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("white-wall-textures.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Anton:wght@400&family=Roboto:wght@300;400;500;700&family=Roboto+Condensed:wght@300;400;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Primary Color Palette */
  --primary-white: #ffffff;
  --primary-blue: #1b2c5a;
  --primary-gold: #d5a32a;
  --primary-gray: #a6a6a6;
  
  /* Secondary Color Palette for Visualizations */
  --secondary-light-gray: #e6e6e6;
  --secondary-dark-gray: #707070;
  --secondary-light-yellow: #f2c94c;
  --secondary-orange: #f2994a;
  --secondary-light-blue: #c4d7f2;
  --secondary-sky-blue: #76b6f2;
  --secondary-dark-blue: #162844;
  --secondary-beige: #f2e8d5;
  --secondary-light-brown: #c1a27b;
  --secondary-dark-brown: #5a483b;
  
  /* Fonts */
  --font-title: 'Anton', sans-serif;
  --font-subtitle: 'Roboto', sans-serif;
  --font-heading: 'Roboto Condensed', sans-serif;
  --font-body: 'Roboto', sans-serif;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: var(--font-body);
  font-weight: 400;
  background: var(--primary-white);
  color: var(--primary-blue);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 1.6;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.bg-wall-texture {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___})	;
  background-size: cover;
  background-repeat: repeat;
  background-position: center;
  background-attachment: fixed; /* Optional: makes it stay in place on scroll */
}

/* Typography */
h1, .title {
  font-family: var(--font-title);
  color: var(--primary-blue);
  font-weight: 400;
  letter-spacing: 0.5px;
  font-size: 2.5rem;
  line-height: 1.2;
  text-transform: uppercase;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-feature-settings: "liga" 1, "kern" 1;
}

h2, h3, h4, .heading {
  font-family: var(--font-heading);
  color: var(--primary-blue);
  font-weight: 700;
  letter-spacing: 0.3px;
  line-height: 1.3;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-feature-settings: "liga" 1, "kern" 1;
}

.subtitle {
  font-family: var(--font-subtitle);
  color: var(--primary-gray);
  font-weight: 400;
}

/* Buttons */
.button-primary {
  background: var(--primary-blue);
  color: var(--primary-white);
  font-family: var(--font-heading);
  font-weight: 700;
  border-radius: 0.75rem;
  padding: 0.875rem 1.75rem;
  font-size: 1rem;
  border: 2px solid var(--primary-blue);
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(27, 44, 90, 0.15);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.button-primary:hover {
  background: var(--primary-gold);
  color: var(--primary-blue);
  border-color: var(--primary-gold);
  box-shadow: 0 6px 16px rgba(213, 163, 42, 0.25);
  transform: translateY(-2px);
}

.button-primary:active {
  transform: translateY(0);
}

.button-secondary {
  background: var(--primary-gold);
  color: var(--primary-blue);
  font-family: var(--font-heading);
  font-weight: 700;
  border-radius: 0.75rem;
  padding: 0.875rem 1.75rem;
  font-size: 1rem;
  border: 2px solid var(--primary-gold);
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(213, 163, 42, 0.15);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.button-secondary:hover {
  background: var(--primary-blue);
  color: var(--primary-gold);
  border-color: var(--primary-blue);
  box-shadow: 0 6px 16px rgba(27, 44, 90, 0.25);
  transform: translateY(-2px);
}

.button-secondary:active {
  transform: translateY(0);
}

/* Background Colors */
.bg-primary {
  background: var(--primary-blue) !important;
}

.bg-gold {
  background: var(--primary-gold) !important;
}

.bg-light-gray {
  background: var(--secondary-light-gray) !important;
}

.bg-dark-gray {
  background: var(--secondary-dark-gray) !important;
}

.bg-white {
  background: var(--primary-white) !important;
}

.bg-light-blue {
  background: var(--secondary-light-blue) !important;
}

.bg-sky-blue {
  background: var(--secondary-sky-blue) !important;
}

.bg-dark-blue {
  background: var(--secondary-dark-blue) !important;
}

.bg-beige {
  background: var(--secondary-beige) !important;
}

.bg-light-brown {
  background: var(--secondary-light-brown) !important;
}

.bg-dark-brown {
  background: var(--secondary-dark-brown) !important;
}

.bg-light-yellow {
  background: var(--secondary-light-yellow) !important;
}

.bg-orange {
  background: var(--secondary-orange) !important;
}

/* Text Colors */
.text-primary {
  color: var(--primary-blue) !important;
}

.text-gold {
  color: var(--primary-gold) !important;
}

.text-gray {
  color: var(--primary-gray) !important;
}

.text-dark-gray {
  color: var(--secondary-dark-gray) !important;
}

.text-white {
  color: var(--primary-white) !important;
}

.text-light-blue {
  color: var(--secondary-light-blue) !important;
}

.text-sky-blue {
  color: var(--secondary-sky-blue) !important;
}

.text-dark-blue {
  color: var(--secondary-dark-blue) !important;
}

.text-beige {
  color: var(--secondary-beige) !important;
}

.text-light-brown {
  color: var(--secondary-light-brown) !important;
}

.text-dark-brown {
  color: var(--secondary-dark-brown) !important;
}

.text-light-yellow {
  color: var(--secondary-light-yellow) !important;
}

.text-orange {
  color: var(--secondary-orange) !important;
}

/* Cards and Components */
.card {
  background: var(--primary-white);
  border: 1px solid var(--secondary-light-gray);
  border-radius: 1rem;
  box-shadow: 0 4px 12px rgba(27, 44, 90, 0.08);
  transition: all 0.3s ease;
}

.card:hover {
  box-shadow: 0 8px 24px rgba(27, 44, 90, 0.12);
  transform: translateY(-2px);
}

/* Links */
a {
  color: var(--primary-blue);
  text-decoration: none;
  transition: all 0.3s ease;
  font-weight: 500;
}

a:hover {
  color: var(--primary-gold);
  text-decoration: underline;
}

/* Form Elements */
input, textarea, select {
  font-family: var(--font-body);
  border: 2px solid var(--secondary-light-gray);
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  transition: all 0.3s ease;
}

input:focus, textarea:focus, select:focus {
  outline: none;
  border-color: var(--primary-blue);
  box-shadow: 0 0 0 3px rgba(27, 44, 90, 0.1);
}

/* Utility Classes */
.shadow-brand {
  box-shadow: 0 4px 12px rgba(27, 44, 90, 0.15);
}

.shadow-gold {
  box-shadow: 0 4px 12px rgba(213, 163, 42, 0.15);
}

.border-brand {
  border-color: var(--primary-blue);
}

.border-gold {
  border-color: var(--primary-gold);
}

/* Responsive Design */
@media (max-width: 768px) {
  .button-primary, .button-secondary {
    padding: 0.75rem 1.5rem;
    font-size: 0.9rem;
  }
  
  h1, .title {
    font-size: 2rem;
    line-height: 1.1;
  }
  
  h2, .heading {
    font-size: 1.5rem;
    line-height: 1.2;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;;EAEvB,+CAA+C;EAC/C,+BAA+B;EAC/B,8BAA8B;EAC9B,iCAAiC;EACjC,2BAA2B;EAC3B,+BAA+B;EAC/B,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;;EAE/B,UAAU;EACV,iCAAiC;EACjC,qCAAqC;EACrC,8CAA8C;EAC9C,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,gCAAgC;EAChC,0BAA0B;EAC1B,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE;aACW;AACb;;AAEA;EACE,0DAAiD;EACjD,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B,EAAE,+CAA+C;AAC/E;;AAEA,eAAe;AACf;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mCAAmC;EACnC,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,yBAAyB;EACzB,6CAA6C;EAC7C,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,iCAAiC;EACjC,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,yBAAyB;EACzB,+CAA+C;EAC/C,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,iCAAiC;EACjC,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,8CAA8C;AAChD;;AAEA,gBAAgB;AAChB;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,yBAAyB;AACzB;EACE,gCAAgC;EAChC,6CAA6C;EAC7C,mBAAmB;EACnB,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA,UAAU;AACV;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,6CAA6C;EAC7C,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA,oBAAoB;AACpB;EACE,6CAA6C;AAC/C;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,sBAAsB;AACtB;EACE;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Anton:wght@400&family=Roboto:wght@300;400;500;700&family=Roboto+Condensed:wght@300;400;700&display=swap');\n\n:root {\n  /* Primary Color Palette */\n  --primary-white: #ffffff;\n  --primary-blue: #1b2c5a;\n  --primary-gold: #d5a32a;\n  --primary-gray: #a6a6a6;\n  \n  /* Secondary Color Palette for Visualizations */\n  --secondary-light-gray: #e6e6e6;\n  --secondary-dark-gray: #707070;\n  --secondary-light-yellow: #f2c94c;\n  --secondary-orange: #f2994a;\n  --secondary-light-blue: #c4d7f2;\n  --secondary-sky-blue: #76b6f2;\n  --secondary-dark-blue: #162844;\n  --secondary-beige: #f2e8d5;\n  --secondary-light-brown: #c1a27b;\n  --secondary-dark-brown: #5a483b;\n  \n  /* Fonts */\n  --font-title: 'Anton', sans-serif;\n  --font-subtitle: 'Roboto', sans-serif;\n  --font-heading: 'Roboto Condensed', sans-serif;\n  --font-body: 'Roboto', sans-serif;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: var(--font-body);\n  font-weight: 400;\n  background: var(--primary-white);\n  color: var(--primary-blue);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  line-height: 1.6;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.bg-wall-texture {\n  background-image: url('white-wall-textures.jpg')\t;\n  background-size: cover;\n  background-repeat: repeat;\n  background-position: center;\n  background-attachment: fixed; /* Optional: makes it stay in place on scroll */\n}\n\n/* Typography */\nh1, .title {\n  font-family: var(--font-title);\n  color: var(--primary-blue);\n  font-weight: 400;\n  letter-spacing: 0.5px;\n  font-size: 2.5rem;\n  line-height: 1.2;\n  text-transform: uppercase;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-feature-settings: \"liga\" 1, \"kern\" 1;\n}\n\nh2, h3, h4, .heading {\n  font-family: var(--font-heading);\n  color: var(--primary-blue);\n  font-weight: 700;\n  letter-spacing: 0.3px;\n  line-height: 1.3;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-feature-settings: \"liga\" 1, \"kern\" 1;\n}\n\n.subtitle {\n  font-family: var(--font-subtitle);\n  color: var(--primary-gray);\n  font-weight: 400;\n}\n\n/* Buttons */\n.button-primary {\n  background: var(--primary-blue);\n  color: var(--primary-white);\n  font-family: var(--font-heading);\n  font-weight: 700;\n  border-radius: 0.75rem;\n  padding: 0.875rem 1.75rem;\n  font-size: 1rem;\n  border: 2px solid var(--primary-blue);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(27, 44, 90, 0.15);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.button-primary:hover {\n  background: var(--primary-gold);\n  color: var(--primary-blue);\n  border-color: var(--primary-gold);\n  box-shadow: 0 6px 16px rgba(213, 163, 42, 0.25);\n  transform: translateY(-2px);\n}\n\n.button-primary:active {\n  transform: translateY(0);\n}\n\n.button-secondary {\n  background: var(--primary-gold);\n  color: var(--primary-blue);\n  font-family: var(--font-heading);\n  font-weight: 700;\n  border-radius: 0.75rem;\n  padding: 0.875rem 1.75rem;\n  font-size: 1rem;\n  border: 2px solid var(--primary-gold);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(213, 163, 42, 0.15);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.button-secondary:hover {\n  background: var(--primary-blue);\n  color: var(--primary-gold);\n  border-color: var(--primary-blue);\n  box-shadow: 0 6px 16px rgba(27, 44, 90, 0.25);\n  transform: translateY(-2px);\n}\n\n.button-secondary:active {\n  transform: translateY(0);\n}\n\n/* Background Colors */\n.bg-primary {\n  background: var(--primary-blue) !important;\n}\n\n.bg-gold {\n  background: var(--primary-gold) !important;\n}\n\n.bg-light-gray {\n  background: var(--secondary-light-gray) !important;\n}\n\n.bg-dark-gray {\n  background: var(--secondary-dark-gray) !important;\n}\n\n.bg-white {\n  background: var(--primary-white) !important;\n}\n\n.bg-light-blue {\n  background: var(--secondary-light-blue) !important;\n}\n\n.bg-sky-blue {\n  background: var(--secondary-sky-blue) !important;\n}\n\n.bg-dark-blue {\n  background: var(--secondary-dark-blue) !important;\n}\n\n.bg-beige {\n  background: var(--secondary-beige) !important;\n}\n\n.bg-light-brown {\n  background: var(--secondary-light-brown) !important;\n}\n\n.bg-dark-brown {\n  background: var(--secondary-dark-brown) !important;\n}\n\n.bg-light-yellow {\n  background: var(--secondary-light-yellow) !important;\n}\n\n.bg-orange {\n  background: var(--secondary-orange) !important;\n}\n\n/* Text Colors */\n.text-primary {\n  color: var(--primary-blue) !important;\n}\n\n.text-gold {\n  color: var(--primary-gold) !important;\n}\n\n.text-gray {\n  color: var(--primary-gray) !important;\n}\n\n.text-dark-gray {\n  color: var(--secondary-dark-gray) !important;\n}\n\n.text-white {\n  color: var(--primary-white) !important;\n}\n\n.text-light-blue {\n  color: var(--secondary-light-blue) !important;\n}\n\n.text-sky-blue {\n  color: var(--secondary-sky-blue) !important;\n}\n\n.text-dark-blue {\n  color: var(--secondary-dark-blue) !important;\n}\n\n.text-beige {\n  color: var(--secondary-beige) !important;\n}\n\n.text-light-brown {\n  color: var(--secondary-light-brown) !important;\n}\n\n.text-dark-brown {\n  color: var(--secondary-dark-brown) !important;\n}\n\n.text-light-yellow {\n  color: var(--secondary-light-yellow) !important;\n}\n\n.text-orange {\n  color: var(--secondary-orange) !important;\n}\n\n/* Cards and Components */\n.card {\n  background: var(--primary-white);\n  border: 1px solid var(--secondary-light-gray);\n  border-radius: 1rem;\n  box-shadow: 0 4px 12px rgba(27, 44, 90, 0.08);\n  transition: all 0.3s ease;\n}\n\n.card:hover {\n  box-shadow: 0 8px 24px rgba(27, 44, 90, 0.12);\n  transform: translateY(-2px);\n}\n\n/* Links */\na {\n  color: var(--primary-blue);\n  text-decoration: none;\n  transition: all 0.3s ease;\n  font-weight: 500;\n}\n\na:hover {\n  color: var(--primary-gold);\n  text-decoration: underline;\n}\n\n/* Form Elements */\ninput, textarea, select {\n  font-family: var(--font-body);\n  border: 2px solid var(--secondary-light-gray);\n  border-radius: 0.5rem;\n  padding: 0.75rem 1rem;\n  transition: all 0.3s ease;\n}\n\ninput:focus, textarea:focus, select:focus {\n  outline: none;\n  border-color: var(--primary-blue);\n  box-shadow: 0 0 0 3px rgba(27, 44, 90, 0.1);\n}\n\n/* Utility Classes */\n.shadow-brand {\n  box-shadow: 0 4px 12px rgba(27, 44, 90, 0.15);\n}\n\n.shadow-gold {\n  box-shadow: 0 4px 12px rgba(213, 163, 42, 0.15);\n}\n\n.border-brand {\n  border-color: var(--primary-blue);\n}\n\n.border-gold {\n  border-color: var(--primary-gold);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .button-primary, .button-secondary {\n    padding: 0.75rem 1.5rem;\n    font-size: 0.9rem;\n  }\n  \n  h1, .title {\n    font-size: 2rem;\n    line-height: 1.1;\n  }\n  \n  h2, .heading {\n    font-size: 1.5rem;\n    line-height: 1.2;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
